import React from 'react';

import News from '../../../Components/news';
import { PostInterface } from '../../../Services/types';

interface RelatedInterface {
    posts: PostInterface[]
}

const Related: React.FC<RelatedInterface> = ({posts}: RelatedInterface) => {

    return (
        <section>
            <div className="bg-gradient-to-b from-light-blue to-white py-6 md:py-10">
                <div className="max-w-screen-xl mx-auto px-4">
                    <h2 className="font-semibold text-2xl md:mb-2 text-center">Leia também</h2>

                    <div className="max-w-screen-lg mx-auto grid md:grid-cols-3 gap-6 mt-8">
                        {posts.slice(0, 3).map((post) => (
                            <News key={post.id} title={post.titulo} excerpt={post.excerpt} date={post.data} slug={post.slug} thumbnail={post.thumbnail} type='simple' />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Related;